import { PickingBatchRouteService } from 'common/data';
import { findParams } from 'core/utils';
import { BaseService } from 'core/services';

class PickingBatchService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new PickingBatchRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	get(id, options) {
		var url = this.routeService.get(id, options);
		return this.apiClient.get(url);
	}

	reprintLabels(id) {
		var url = this.routeService.reprintLabels(id);
		return this.apiClient.get(url);
	}

	exportPickingBatch(id) {
		var url = this.routeService.exportPickingBatch(id);
		return this.apiClient.get(url);
	}

	generatePdf(id) {
		var url = this.routeService.generatePdf(id);
		return this.apiClient.get(url);
	}

	resendToWms(id) {
		var url = this.routeService.resendToWms(id);
		return this.apiClient.get(url);
	}
}

export default PickingBatchService;



// WEBPACK FOOTER //
// ./src/common/data/services/PickingBatchService.js